import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const allAnnonceType = createAsyncThunk("annonce/allAnnonceType", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "annonce/allAnnonceType", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const annonce = await response.json();
  return annonce;
});

export const allAnnonceFive = createAsyncThunk("annonce/allAnnonceFive", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "annonce/allAnnonceFive", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const annonce = await response.json();
  return annonce;
});
export const saveImageAnnonce = createAsyncThunk("annonce/saveImageAnnonce", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "annonce/saveImageAnnonce", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const annonce = await response.json();
  return annonce;
});
export const fetchAnnonce = createAsyncThunk("annonce/fetchAnnonce", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "annonce/allAnnonce", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const annonce = await response.json();
  return annonce;
});

export const annonceNewAdded = createAsyncThunk("annonce/annonceNewAdded", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "annonce/annonceNewAdded", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)

  });
  const annonce = await response.json();
  return annonce;
});

export const annonceAdded = createAsyncThunk("annonce/addAnnonce", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "annonce/addAnnonce", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)

  });
  const annonce = await response.json();
  return annonce;
});
export const annonceUpdated = createAsyncThunk("annonce/updateAnnonce", async (data) => {
  const response = await fetch(Configuration.BACK_BASEURL + "annonce/addAnnonce", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(data),
  });

  const annonce = await response.json();
  return annonce;
});
export const annonceGetById = createAsyncThunk("annonce/annonceGetById", async (id1) => {
  const id = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "annonce/getAnnonce", {
    method: 'POST',
    headers: {
      'id': id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const annonce = await response.json();
  return annonce;
});
const annonceReduce = createSlice({
  name: "annonce",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    annonceDeleted(state, action) {
      const { id } = action.payload;
      return new Promise((resolve, reject) => {
        fetch(Configuration.BACK_BASEURL + "annonce/deleteAnnonce/" + id, {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': token
          },
        })
        .then(response => {
          console.log('Annonce supprimée avec succès');
          resolve(); // Résoudre la promesse si la suppression réussit
        })
        .catch(error => {
          console.error('Erreur lors de la suppression de l\'annonce:', error);
          reject(error); // Rejeter la promesse en cas d'erreur
        });
      });
    },
    

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnnonce.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchAnnonce.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(fetchAnnonce.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(annonceGetById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(annonceGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(annonceGetById.rejected, (state, action) => {
        state.loading = false;
      });
  },

});

export const { annonceDeleted } = annonceReduce.actions;

export default annonceReduce.reducer;
